import { jsx as _jsx } from "react/jsx-runtime";
import { withVariants } from './util';
const IconSize32 = (_jsx("svg", Object.assign({ id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 60 60" }, { children: _jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M52.64,15.25l-7.99-10.04c-1.03-1.29-2.58-2.04-4.22-2.04H6.17V56.83H53.83V18.65c0-1.23-.42-2.43-1.18-3.39ZM26.27,5.75h12.53v14.71h-12.53V5.75Zm16.67,48.5H17.73v-14.57h25.22v14.57Zm8.3,0h-5.73v-17.14H15.16v17.14h-6.41V5.75h6.41V23.04h26.22V5.93c.49,.17,.93,.47,1.26,.89l7.99,10.04c.4,.51,.62,1.14,.62,1.79V54.25Z" }, void 0) }), void 0));
export const variants = {
    default: IconSize32,
};
export default withVariants(variants);
